export const useSmsAutomationAccess = () => true;
